import React, { useState, useMemo } from 'react';
import quickLinksData from './quick-links-data.json';
import { BRAND_ICONS } from '@app/components/BrandIcons';

interface QuickLink {
  name: string;
  url: string;
  iconBg: string;
  iconEmoji: string;
}

interface QuickLinkSection {
  section: string;
  links: QuickLink[];
}

export const QuickLinks: React.FC = () => {
  const [search, setSearch] = useState('');
  const sections = quickLinksData as QuickLinkSection[];

  const filteredSections = useMemo(() => {
    if (!search) return sections;
    const q = search.toLowerCase();
    return sections
      .map((s) => ({
        ...s,
        links: s.links.filter(
          (l) =>
            l.name.toLowerCase().includes(q) ||
            s.section.toLowerCase().includes(q)
        ),
      }))
      .filter((s) => s.links.length > 0);
  }, [sections, search]);

  return (
    <div className="quicklinks-page">
      <div className="page-header">
        <h1>Quick Links</h1>
        <p>Access all your favorite tools and applications in one place</p>
      </div>

      <div className="quicklinks-search">
        <div className="quicklinks-search-wrapper">
          <span className="quicklinks-search-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </span>
          <input
            type="text"
            placeholder="Search apps and tools..."
            aria-label="Search quick links"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {filteredSections.map((section) => (
        <div key={section.section} className="quicklinks-section">
          <div className="quicklinks-section-title">{section.section}</div>
          <div className="quicklinks-grid">
            {section.links.map((link) => {
              const BrandIcon = BRAND_ICONS[link.name];
              return (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="quicklink-card"
                >
                  <div
                    className="quicklink-icon"
                    style={{ background: link.iconBg }}
                  >
                    {BrandIcon
                      ? <BrandIcon size={28} color="#fff" />
                      : <span style={{ fontSize: 28 }}>{link.iconEmoji}</span>
                    }
                  </div>
                  <div className="quicklink-name">{link.name}</div>
                </a>
              );
            })}
          </div>
        </div>
      ))}

      {filteredSections.length === 0 && (
        <div className="quicklinks-empty">
          No links match your search. Try a different query.
        </div>
      )}
    </div>
  );
};
